import { render, staticRenderFns } from "./ApprovalMessage.vue?vue&type=template&id=76022a78&"
import script from "./ApprovalMessage.vue?vue&type=script&lang=js&"
export * from "./ApprovalMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports